/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProcedureConsumable from './procedure-consumable';
import ProcedureConsumableDetail from './procedure-consumable-detail';
import ProcedureConsumableUpdate from './procedure-consumable-update';
import ProcedureConsumableDeleteDialog from './procedure-consumable-delete-dialog';

const ProcedureConsumableRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProcedureConsumable />} />
    <Route path="new" element={<ProcedureConsumableUpdate />} />
    <Route path=":id">
      <Route index element={<ProcedureConsumableDetail />} />
      <Route path="edit" element={<ProcedureConsumableUpdate />} />
      <Route path="delete" element={<ProcedureConsumableDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProcedureConsumableRoutes;
